// This is from widgetconfig.json in dashboard
// ClearScripts Printing
export const AllMedications = 'All';
export const ActiveMedications = 'Active'; // DocLink Printing

export const Card = 'Card';
export const Listing = 'Listing'; // Manifest Printing

export const Contents = 'Contents';